import { injectable, inject } from '@patsnap/tahiti-core/shared/inversify';
import type { IPackageType } from '@telecom/shared/domain/permission/apis/package-api';
import { PackageApi } from '@telecom/shared/domain/permission/apis/package-api';
import type { PackageInfoService } from '../package-info-service';

/**
 * 套餐信息服务实现
 */
@injectable()
export class PackageInfoServiceImpl implements PackageInfoService {
    private _cachedPackageInfo: IPackageType[] | null = null;
    private _loadingPromise: Promise<IPackageType[]> | null = null;

    constructor(
        @inject(PackageApi)
        private _packageApi: PackageApi,
    ) {}

    /**
     * 获取用户套餐信息
     * 如果已有缓存则返回缓存，否则从 API 获取
     */
    public async getPackageInfo(): Promise<IPackageType[]> {
        // 如果已有缓存，直接返回
        if (this._cachedPackageInfo) {
            return this._cachedPackageInfo;
        }

        // 如果正在加载中，返回加载中的 Promise
        if (this._loadingPromise) {
            return this._loadingPromise;
        }

        // 开始加载
        this._loadingPromise = this._packageApi.getUserPackageType()
            .then(packages => {
                this._cachedPackageInfo = packages;
                this._loadingPromise = null;
                return packages;
            })
            .catch(error => {
                this._loadingPromise = null;
                throw error;
            });

        return this._loadingPromise;
    }
}
